import { render } from "./ModalFinalizarPlanoPAP.vue?vue&type=template&id=00c44583"
import script from "./ModalFinalizarPlanoPAP.vue?vue&type=script&lang=js"
export * from "./ModalFinalizarPlanoPAP.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__